import React from 'react';
import { PrimaryNavLink } from 'basecamp';
import { useResponsiveMenu, useWindowSize } from '../../../utils/hooks';
import { useSelector } from 'react-redux';
import { getFeature } from 'features/app/redux/features';
import { translate } from '../../../utils/locale';

const ks5Measures = 'primaryNavigation.connect.ks5Measures';

const useKs5PerformanceMeasuresNavLinks = () => {
	const canViewKs5PmSubNav = useSelector(getFeature('expanded_ks5_performance_measures'));
	const canViewALevel = useSelector(getFeature('ks5_a_level_perf_measures'));
	const canViewSummary = useSelector(getFeature('ks5_pm_summary'));
	const canViewAgq = useSelector(getFeature('ks5_pm_agq'));
	const canViewTechLevel = useSelector(getFeature('ks5_pm_tech_level'));
	const canViewAcademic = useSelector(getFeature('ks5_pm_academic'));

	/**
	 * Configuration array for the KS5 Performance Measures sub-navigation links.
	 * Display order (AC): Summary, A Level, AGQ, Tech Levels, Academic.
	 */
	const ks5PerformanceMeasuresNavLinks = [
		{
			name: 'ks5Summary',
			width: 110,
			isVisible: canViewKs5PmSubNav && canViewSummary,
			menuTransferOrder: 1,
			component: (
				<PrimaryNavLink
					setAs="secondary"
					data-test="primary-nav-ks5-summary-link"
					withInternalUrl="/Ks5PerformanceMeasures/summary"
				>
					{translate(`${ks5Measures}.SUMMARY`)}
				</PrimaryNavLink>
			),
		},
		{
			name: 'ks5ALevel',
			width: 110,
			isVisible: canViewKs5PmSubNav && canViewALevel,
			menuTransferOrder: 2,
			component: (
				<PrimaryNavLink
					setAs="secondary"
					data-test="primary-nav-ks5-alevel-link"
					withInternalUrl="/Ks5PerformanceMeasures/Alevel"
				>
					{translate(`${ks5Measures}.A_LEVEL`)}
				</PrimaryNavLink>
			),
		},
		{
			name: 'ks5Agq',
			width: 110,
			isVisible: canViewKs5PmSubNav && canViewAgq,
			menuTransferOrder: 3,
			component: (
				<PrimaryNavLink
					setAs="secondary"
					data-test="primary-nav-ks5-agq-link"
					withInternalUrl="/Ks5PerformanceMeasures/agq"
				>
					{translate(`${ks5Measures}.AGQ`)}
				</PrimaryNavLink>
			),
		},
		{
			name: 'ks5TechLevels',
			width: 110,
			isVisible: canViewKs5PmSubNav && canViewTechLevel,
			menuTransferOrder: 4,
			component: (
				<PrimaryNavLink
					setAs="secondary"
					data-test="primary-nav-ks5-tech-level-link"
					withInternalUrl="/Ks5PerformanceMeasures/tech-level"
				>
					{translate(`${ks5Measures}.TECH_LEVELS`)}
				</PrimaryNavLink>
			),
		},
		{
			name: 'ks5Academic',
			width: 110,
			isVisible: canViewKs5PmSubNav && canViewAcademic,
			menuTransferOrder: 5,
			component: (
				<PrimaryNavLink
					setAs="secondary"
					data-test="primary-nav-ks5-academic-link"
					withInternalUrl="/Ks5PerformanceMeasures/academic"
				>
					{translate(`${ks5Measures}.ACADEMIC`)}
				</PrimaryNavLink>
			),
		},
	];

	/**
	 * Get the current window width to determine responsive menu breakpoints
	 * @type {number} width - Current window width in pixels
	 */
	const { width } = useWindowSize();

	// Generate responsive menus based on screen size and dependencies
	const { largeScreenMenu, smallScreenMenu } = useResponsiveMenu(
		ks5PerformanceMeasuresNavLinks,
		width,
		0,
		[]
	);

	return { largeScreenMenu, smallScreenMenu };
};

export default useKs5PerformanceMeasuresNavLinks;
